import React, { useState, useEffect, useRef } from "react";
import { IoMdSend } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import {
  useGetVizardDataMutation,
  useGetColumnNamesQuery,
} from "./dataApiSlice";
//Danish khan khan khan
import {
  getL1SheetProperty,
  resetSheet,
  setLevel2Properties,
  setWorkbookProperty,
  updateL1Property,
  updateLevel2Properties,
} from "./WorkbookSlice";
import { buildReduxStateFromResponse } from "./vizard/buildReduxState";
import {
  getAside2components,
  getDefaultReduxState,
} from "../../middleware/getVizDetails";
import { buildCustomization } from "../../middleware/buildInitialSheetState";

export default function Aside4({
  Sheetid,
  vizType,
  getVizardData,
  isVizardLoading,
  vizardData,
  isVizardError,
  vizardError,
}) {
  const [inputText, setInputText] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);
  const inputBoxRef = useRef(null);

  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputBoxRef.current && !inputBoxRef.current.contains(event.target)) {
        setIsInputVisible(false); // Close the input box when clicking outside
      }
    };

    // Adding event listener for click outside
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dispatch = useDispatch();

  const {
    data: columnData,
    isLoading: isColumnNamesLoading,
    isSuccess: isColumnNamesSuccess,
    isError: isColumnNamesError,
    error: columnNamesError,
  } = useGetColumnNamesQuery(dataSourceID, {
    skip: !dataSourceID, // Skip if no dataSourceID
  });

  const handleResetSheet = () => {
    const sheet = getDefaultReduxState({ vizType: vizType }).newSheetState;
    const actions = {
      onClick: {},
      onDoubleClick: {},
      sort: [],
      quickTable: [],
    };

    const { CustomizeArrayComponents } = getAside2components(vizType);

    let customizationObject = buildCustomization(CustomizeArrayComponents);
    // console.log(customizationObject);
    dispatch(
      resetSheet({
        Sheetid,
        query: sheet["query"],
        customization: customizationObject,
        actions,
      })
    );
  };

  const handleSend = () => {
    handleResetSheet();
    if (inputText.trim()) {
      const body = {
        databaseID: dataSourceID,
        query: inputText,
        conversationId: Sheetid,
      };
      getVizardData(body);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey || !e.shiftKey)) {
      handleSend();
    }
  };

  useEffect(() => {
    if (vizardData && columnData) {
      // console.log("ran");
      const newQueryReduxState = buildReduxStateFromResponse(
        vizardData,
        columnData,
        Sheetid,
        dataSourceID
      );
      const {
        query,
        sort,
        vizType: vizTypeFromTauu,
        quickTable,
        calculatedField,
      } = newQueryReduxState;
      // console.log(query);
      // console.log(query.filters);
      // console.log(vizType);
      // console.log(quickTable);

      dispatch(
        updateL1Property({ SheetId: Sheetid, key: "query", value: query })
      );
      dispatch(
        updateLevel2Properties({
          reduxKey: "sort",
          Sheetid,
          parentKey: "actions",
          value: sort,
          itemInArray: false,
          index: null,
        })
      );
      if (quickTable) {
        dispatch(
          setLevel2Properties({
            reduxKey: "quickTable",
            Sheetid,
            parentKey: "actions",
            value: quickTable,
            itemInArray: true,
          })
        );
      }
      if (calculatedField) {
        dispatch(
          setWorkbookProperty({
            key: "calculatedFields",
            value: calculatedField,
            itemInArray: true,
          })
        );
      }
      if (vizTypeFromTauu) {
        dispatch(
          updateL1Property({
            SheetId: Sheetid,
            key: "VizType",
            value: vizTypeFromTauu,
            currentVizTpe: vizType,
          })
        );
      }
    }
  }, [vizardData, columnData]);

  const aside2Components =
    getAside2components(vizType).CustomizeArrayComponents;
  // console.log(aside2Components);

  let customizationObject = {};
  aside2Components.forEach((element) => {
    customizationObject[element.reduxKey] = element.defaultValue;
  });

  // console.log(customizationObject);

  return (
    <>
      <main
        className={`w-full flex items-center justify-between h-full px-[2px]`}
      >
        {/* Input Box with Slide Animation */}
        <div className="w-[95%] h-full flex items-start pt-[1px] justify-center">
          <input
            type="text"
            placeholder={"tauu se pucho...!"}
            className="flex-grow h-full outline-none px-2 text-sm focus:ring-0 focus:ring-blue-400"
            value={inputText}
            onKeyDown={handleKeyDown}
            onChange={(e) => setInputText(e.target.value)}
          />
          <button
            onClick={handleSend}
            disabled={isVizardLoading || isColumnNamesLoading}
            className="h-full w-[50px] flex items-center justify-center bg-blue-950 text-white rounded-r-md transition-all duration-300"
          >
            <IoMdSend className="text-xl" />
          </button>
        </div>

        {/* Tauu Icon */}
        <button className="w-[5%] h-full " title="Open Input Box">
          <img
            onClick={() => setIsInputVisible(!isInputVisible)}
            src="/graph_img/NewTau.png"
            alt="Tau"
            className="w-full h-full object-contain cursor-pointer"
          />
        </button>
      </main>
    </>
  );
}
